module.exports = __webpack_public_path__ + "static/ff-saleslanding-image-body-joinrevolution-jesse-dodds-ZjDhntvNzAs-unsplash.62974cd7.jpg";